// Generated by `npm run icons:build` from libs/shared-assets/svg-source. Do not edit.

export const iconNames = [
  'action-16',
  'admin-16',
  'ai-16',
  'alarm-clock-sleep-16',
  'alarm-clock-sleep-fill-16',
  'alert-50',
  'apple',
  'arrow down',
  'arrow-down',
  'arrow-down-12',
  'arrow-down-16',
  'arrow-down-2-16',
  'arrow-left-12',
  'arrow-left-16',
  'arrow-right-12',
  'arrow-right-16',
  'arrow-up-12',
  'arrow-up-16',
  'arrow-up-2-16',
  'assign-driver-arrow',
  'author-16',
  'avatar',
  'bank-16',
  'bank-32',
  'bank-50',
  'burger-16',
  'business-16',
  'business-32',
  'business-50',
  'cake-16',
  'calendar-16',
  'calendar-50',
  'calendar-important-16',
  'calendar-location-16',
  'calendar-payment-16',
  'carrier-unit-dnd-arrow',
  'checkmark',
  'checkmark-12',
  'checkmark-16',
  'checkmark-2-16',
  'checkmark-2-20',
  'checkmark-2-32',
  'checkmark-20',
  'checkmark-50',
  'checkmark-double-16',
  'checkpoint-16',
  'clock-16',
  'clock-2-16',
  'clock-20',
  'clock-32',
  'clock-50',
  'code-16',
  'collapse-16',
  'columns-16',
  'company-16',
  'company-32',
  'company-50',
  'congratulation-100',
  'contacts-book-16',
  'conversation-16',
  'conversation-20',
  'credit-card-16',
  'customer-from-outside-16',
  'decor',
  'dimension-16',
  'dimension-32',
  'dims-20',
  'doc-20',
  'doc-32',
  'doc-50',
  'doc-insurance-32',
  'doc-ms-no-50',
  'doc-ss4-32',
  'doc-ss4-50',
  'doc-van-32',
  'doc-van-50',
  'document-180x250',
  'document-tsa-285x390',
  'double-checkmark',
  'download-16',
  'driver-16',
  'driver-50',
  'driver-license-landscape-250x180',
  'duplicate-16',
  'edit-16',
  'edit-20',
  'emoji-awesome-20',
  'emoji-awesome-32',
  'emoji-bad-20',
  'emoji-bad-32',
  'emoji-bad-50',
  'emoji-great-20',
  'emoji-great-32',
  'emoji-normal-20',
  'emoji-normal-32',
  'emoji-very bad-20',
  'emoji-very bad-32',
  'emoji-very-bad-20',
  'emoji-very-bad-32',
  'enter-16',
  'expand-16',
  'eye-16',
  'filters-16',
  'fr8bot-16',
  'funnel-16',
  'gender-16',
  'globe-16',
  'globe-20',
  'globe-pointer-16',
  'green-card-32',
  'green-card-50',
  'grid-16',
  'group-20',
  'group-50',
  'headphones-16',
  'history-50',
  'id-32',
  'id-50',
  'info-16',
  'info-20',
  'info-32',
  'info-50',
  'invitation-50',
  'label-16',
  'list-12',
  'load-16',
  'load-20',
  'load-32',
  'load-50',
  'load-done-50',
  'load-remove-50',
  'load-status-16',
  'lock-16',
  'log-out-16',
  'mail-16',
  'mail-20',
  'mail-32',
  'mail-50',
  'mainpage-contact-mail',
  'mainpage-contact-phone',
  'manager-20',
  'manager-50',
  'map pointer 2',
  'map-16',
  'map-20',
  'map-point-16',
  'map-point-32',
  'map-point-solid-12',
  'map-point-solid-16',
  'map-point-solid-32',
  'map-pointer-2-16',
  'map-pointer-2-20',
  'menu-x',
  'message-16',
  'metric-16',
  'minus-16',
  'more-16',
  'move-12',
  'neutrally-32',
  'notes-16',
  'notes-20',
  'notification-20',
  'on-the-way',
  'passport-32',
  'passport-50',
  'password-16',
  'password-50',
  'path-16',
  'path-20',
  'path-50',
  'percent-16',
  'phone-16',
  'phone-32',
  'phone-50',
  'photo-camera-16',
  'photo-camera-20',
  'photo-camera-32',
  'photo-camera-50',
  'photo-camera-no-16',
  'plane-solid-12',
  'plane-solid-16',
  'plane-solid-32',
  'plus-16',
  'plus-32',
  'pointer-50',
  'profile-16',
  'profile-2-16',
  'profile-20',
  'profile-32',
  'profile-50',
  'profile-card-16',
  'profile-card-20',
  'profile-new-16',
  'profile-with-something-16',
  'question-16',
  'question-50',
  'reload',
  'reload-12',
  'reload-16',
  'replace-16',
  'reply-16',
  'req-ac',
  'req-air-ride',
  'req-dock-high',
  'req-hazmat',
  'req-heater',
  'req-lift-fate-with-line',
  'req-lift-gate',
  'req-pallet-jack',
  'req-size',
  'req-speed',
  'req-speed-with-line',
  'revenue-16',
  'revenue-20',
  'revenue-32',
  'revenue-50',
  'revenue-with-line',
  'review-16',
  'rotate-l-16',
  'rotate-left-16',
  'rotate-phone',
  'rotate-phone-2',
  'rotate-r-16',
  'rotate-right-16',
  'routing-number-16',
  'search-16',
  'search-50',
  'ship-16',
  'ship-solid-12',
  'ship-solid-32',
  'shipper-16',
  'shipper-20',
  'shipper-50',
  'star-16',
  'start-border',
  'start-fill',
  'steering-wheel-16',
  'step-cards-20',
  'structure-16',
  'support-16',
  'support-20',
  'support-32',
  'support-50',
  'suspended-16',
  'suspended-50',
  'tag-50',
  'template-12',
  'template-16',
  'trash-16',
  'twic-50',
  'twic-back-180x250',
  'twic-front-180x250',
  'unassign-16',
  'unread-16',
  'up-down-50',
  'upload-16',
  'van-16',
  'van-20',
  'van-24',
  'van-32',
  'van-50',
  'van-back-180x250',
  'van-cargo-space-180x250',
  'van-front-180x250',
  'van-left-side-180x250',
  'van-new-20',
  'van-new-50',
  'van-plate-16',
  'van-plate-20',
  'van-right-side-180x250',
  'visible-no-16',
  'visible-yes-16',
  'warning-16',
  'warning-20',
  'web-aero-docs',
  'web-agro',
  'web-business',
  'web-car',
  'web-checkmark-approved',
  'web-choose',
  'web-facebook',
  'web-instagram',
  'web-linkedin',
  'web-manufactory',
  'web-map',
  'web-page',
  'web-path',
  'web-pharma',
  'web-plane',
  'web-plug',
  'web-polygon',
  'web-progress-01',
  'web-progress-02',
  'web-progress-03',
  'web-progress-checkmark',
  'web-progress-empty',
  'web-progress-van',
  'web-revenue',
  'web-shield',
  'web-stage',
  'web-support',
  'web-tracking',
  'web-wirehouse',
  'web-youtube',
  'weight-32',
  'withdraw-50',
  'work-card-32',
  'work-card-50',
  'x',
  'x-1-12',
  'x-1-16',
  'x-2-16',
  'x-2-20',
  'x-2-32',
  'x-2-50',
] as const;

export type IconName = (typeof iconNames)[number];

export type IconFont = 'fr8bot-icons' | 'fr8bot-landing-icons';

/**
 * A glyph: its font, its character, the colour it is painted (a fixed-colour icon) and the
 * width / height of its drawing (a non-square icon, to fit a non-square host).
 */
export interface IconGlyph {
  font: IconFont;
  char: string;
  colour?: string;
  aspect?: number;
}

/** Every icon is a glyph of one of the fonts. */
export const iconFontGlyphs: Readonly<Record<IconName, IconGlyph>> = {
  'action-16': { font: 'fr8bot-icons', char: '\uf1f6' },
  'admin-16': { font: 'fr8bot-icons', char: '\uf1f5' },
  'ai-16': { font: 'fr8bot-icons', char: '\uf1f4' },
  'alarm-clock-sleep-16': { font: 'fr8bot-icons', char: '\uf1f3' },
  'alarm-clock-sleep-fill-16': { font: 'fr8bot-icons', char: '\uf1f2' },
  'alert-50': { font: 'fr8bot-icons', char: '\uf1f1' },
  apple: { font: 'fr8bot-icons', char: '\uf202', colour: '#D7D7D7' },
  'arrow down': { font: 'fr8bot-icons', char: '\uf1f0' },
  'arrow-down': { font: 'fr8bot-icons', char: '\uf1ec' },
  'arrow-down-12': { font: 'fr8bot-icons', char: '\uf1ef' },
  'arrow-down-16': { font: 'fr8bot-icons', char: '\uf1ee' },
  'arrow-down-2-16': { font: 'fr8bot-icons', char: '\uf1ed' },
  'arrow-left-12': { font: 'fr8bot-icons', char: '\uf1eb' },
  'arrow-left-16': { font: 'fr8bot-icons', char: '\uf1ea' },
  'arrow-right-12': { font: 'fr8bot-icons', char: '\uf1e9' },
  'arrow-right-16': { font: 'fr8bot-icons', char: '\uf1e8' },
  'arrow-up-12': { font: 'fr8bot-icons', char: '\uf1e7' },
  'arrow-up-16': { font: 'fr8bot-icons', char: '\uf1e6' },
  'arrow-up-2-16': { font: 'fr8bot-icons', char: '\uf1e5' },
  'assign-driver-arrow': {
    font: 'fr8bot-icons',
    char: '\uf204',
    colour: '#C1D91C',
    aspect: 2.0789,
  },
  'author-16': { font: 'fr8bot-icons', char: '\uf1e4' },
  avatar: { font: 'fr8bot-icons', char: '\uf201', colour: '#D7D7D7' },
  'bank-16': { font: 'fr8bot-icons', char: '\uf1e3' },
  'bank-32': { font: 'fr8bot-icons', char: '\uf1e2' },
  'bank-50': { font: 'fr8bot-icons', char: '\uf1e1' },
  'burger-16': { font: 'fr8bot-icons', char: '\uf1e0' },
  'business-16': { font: 'fr8bot-icons', char: '\uf1df' },
  'business-32': { font: 'fr8bot-icons', char: '\uf1de' },
  'business-50': { font: 'fr8bot-icons', char: '\uf1dd' },
  'cake-16': { font: 'fr8bot-icons', char: '\uf1dc' },
  'calendar-16': { font: 'fr8bot-icons', char: '\uf1db' },
  'calendar-50': { font: 'fr8bot-icons', char: '\uf1da' },
  'calendar-important-16': { font: 'fr8bot-icons', char: '\uf1d9' },
  'calendar-location-16': { font: 'fr8bot-icons', char: '\uf1d8' },
  'calendar-payment-16': { font: 'fr8bot-icons', char: '\uf1d7' },
  'carrier-unit-dnd-arrow': { font: 'fr8bot-icons', char: '\uf203', aspect: 2.2222 },
  checkmark: { font: 'fr8bot-icons', char: '\uf10f', aspect: 1.3333 },
  'checkmark-12': { font: 'fr8bot-icons', char: '\uf1d6' },
  'checkmark-16': { font: 'fr8bot-icons', char: '\uf1d5' },
  'checkmark-2-16': { font: 'fr8bot-icons', char: '\uf1d4' },
  'checkmark-2-20': { font: 'fr8bot-icons', char: '\uf1d3' },
  'checkmark-2-32': { font: 'fr8bot-icons', char: '\uf1d2' },
  'checkmark-20': { font: 'fr8bot-icons', char: '\uf1d1' },
  'checkmark-50': { font: 'fr8bot-icons', char: '\uf1d0' },
  'checkmark-double-16': { font: 'fr8bot-icons', char: '\uf1ff' },
  'checkpoint-16': { font: 'fr8bot-icons', char: '\uf1cf' },
  'clock-16': { font: 'fr8bot-icons', char: '\uf1ce' },
  'clock-2-16': { font: 'fr8bot-icons', char: '\uf1cd' },
  'clock-20': { font: 'fr8bot-icons', char: '\uf1cc' },
  'clock-32': { font: 'fr8bot-icons', char: '\uf1cb' },
  'clock-50': { font: 'fr8bot-icons', char: '\uf1ca' },
  'code-16': { font: 'fr8bot-icons', char: '\uf1c9' },
  'collapse-16': { font: 'fr8bot-icons', char: '\uf1c8' },
  'columns-16': { font: 'fr8bot-icons', char: '\uf1c7' },
  'company-16': { font: 'fr8bot-icons', char: '\uf1c6' },
  'company-32': { font: 'fr8bot-icons', char: '\uf1c5' },
  'company-50': { font: 'fr8bot-icons', char: '\uf1c4' },
  'congratulation-100': { font: 'fr8bot-icons', char: '\uf1c3' },
  'contacts-book-16': { font: 'fr8bot-icons', char: '\uf1c2' },
  'conversation-16': { font: 'fr8bot-icons', char: '\uf1c1' },
  'conversation-20': { font: 'fr8bot-icons', char: '\uf1c0' },
  'credit-card-16': { font: 'fr8bot-icons', char: '\uf1bf' },
  'customer-from-outside-16': { font: 'fr8bot-icons', char: '\uf1be' },
  decor: { font: 'fr8bot-icons', char: '\uf219', colour: '#C1D91C', aspect: 5.25 },
  'dimension-16': { font: 'fr8bot-icons', char: '\uf1bd' },
  'dimension-32': { font: 'fr8bot-icons', char: '\uf1bc' },
  'dims-20': { font: 'fr8bot-icons', char: '\uf1fd' },
  'doc-20': { font: 'fr8bot-icons', char: '\uf1bb' },
  'doc-32': { font: 'fr8bot-icons', char: '\uf1ba' },
  'doc-50': { font: 'fr8bot-icons', char: '\uf1b9' },
  'doc-insurance-32': { font: 'fr8bot-icons', char: '\uf1b8' },
  'doc-ms-no-50': { font: 'fr8bot-icons', char: '\uf1b7' },
  'doc-ss4-32': { font: 'fr8bot-icons', char: '\uf1b6' },
  'doc-ss4-50': { font: 'fr8bot-icons', char: '\uf1b5' },
  'doc-van-32': { font: 'fr8bot-icons', char: '\uf1b4' },
  'doc-van-50': { font: 'fr8bot-icons', char: '\uf1b3' },
  'document-180x250': { font: 'fr8bot-icons', char: '\uf218', aspect: 0.72 },
  'document-tsa-285x390': { font: 'fr8bot-icons', char: '\uf21a', aspect: 0.7308 },
  'double-checkmark': { font: 'fr8bot-icons', char: '\uf10e', aspect: 1.3333 },
  'download-16': { font: 'fr8bot-icons', char: '\uf1b2' },
  'driver-16': { font: 'fr8bot-icons', char: '\uf1b1' },
  'driver-50': { font: 'fr8bot-icons', char: '\uf1b0' },
  'driver-license-landscape-250x180': { font: 'fr8bot-icons', char: '\uf217', aspect: 1.3889 },
  'duplicate-16': { font: 'fr8bot-icons', char: '\uf1f8', aspect: 1.0625 },
  'edit-16': { font: 'fr8bot-icons', char: '\uf1af' },
  'edit-20': { font: 'fr8bot-icons', char: '\uf1ae' },
  'emoji-awesome-20': { font: 'fr8bot-icons', char: '\uf1ad' },
  'emoji-awesome-32': { font: 'fr8bot-icons', char: '\uf1ac' },
  'emoji-bad-20': { font: 'fr8bot-icons', char: '\uf1ab' },
  'emoji-bad-32': { font: 'fr8bot-icons', char: '\uf1aa' },
  'emoji-bad-50': { font: 'fr8bot-icons', char: '\uf1a9' },
  'emoji-great-20': { font: 'fr8bot-icons', char: '\uf1a8' },
  'emoji-great-32': { font: 'fr8bot-icons', char: '\uf1a7' },
  'emoji-normal-20': { font: 'fr8bot-icons', char: '\uf1a6' },
  'emoji-normal-32': { font: 'fr8bot-icons', char: '\uf1a5' },
  'emoji-very bad-20': { font: 'fr8bot-icons', char: '\uf1a4' },
  'emoji-very bad-32': { font: 'fr8bot-icons', char: '\uf1a3' },
  'emoji-very-bad-20': { font: 'fr8bot-icons', char: '\uf1a2' },
  'emoji-very-bad-32': { font: 'fr8bot-icons', char: '\uf1a1' },
  'enter-16': { font: 'fr8bot-icons', char: '\uf1a0' },
  'expand-16': { font: 'fr8bot-icons', char: '\uf19f' },
  'eye-16': { font: 'fr8bot-icons', char: '\uf19e' },
  'filters-16': { font: 'fr8bot-icons', char: '\uf19d' },
  'fr8bot-16': { font: 'fr8bot-icons', char: '\uf19c' },
  'funnel-16': { font: 'fr8bot-icons', char: '\uf19b' },
  'gender-16': { font: 'fr8bot-icons', char: '\uf19a' },
  'globe-16': { font: 'fr8bot-icons', char: '\uf199' },
  'globe-20': { font: 'fr8bot-icons', char: '\uf198' },
  'globe-pointer-16': { font: 'fr8bot-icons', char: '\uf197' },
  'green-card-32': { font: 'fr8bot-icons', char: '\uf196' },
  'green-card-50': { font: 'fr8bot-icons', char: '\uf195' },
  'grid-16': { font: 'fr8bot-icons', char: '\uf194' },
  'group-20': { font: 'fr8bot-icons', char: '\uf193' },
  'group-50': { font: 'fr8bot-icons', char: '\uf1fc', aspect: 0.9804 },
  'headphones-16': { font: 'fr8bot-icons', char: '\uf192' },
  'history-50': { font: 'fr8bot-icons', char: '\uf191' },
  'id-32': { font: 'fr8bot-icons', char: '\uf190' },
  'id-50': { font: 'fr8bot-icons', char: '\uf18f' },
  'info-16': { font: 'fr8bot-icons', char: '\uf18e' },
  'info-20': { font: 'fr8bot-icons', char: '\uf18d' },
  'info-32': { font: 'fr8bot-icons', char: '\uf18c' },
  'info-50': { font: 'fr8bot-icons', char: '\uf18b' },
  'invitation-50': { font: 'fr8bot-icons', char: '\uf18a' },
  'label-16': { font: 'fr8bot-icons', char: '\uf1fb' },
  'list-12': { font: 'fr8bot-icons', char: '\uf189' },
  'load-16': { font: 'fr8bot-icons', char: '\uf188' },
  'load-20': { font: 'fr8bot-icons', char: '\uf187' },
  'load-32': { font: 'fr8bot-icons', char: '\uf186' },
  'load-50': { font: 'fr8bot-icons', char: '\uf185' },
  'load-done-50': { font: 'fr8bot-icons', char: '\uf184' },
  'load-remove-50': { font: 'fr8bot-icons', char: '\uf183' },
  'load-status-16': { font: 'fr8bot-icons', char: '\uf182' },
  'lock-16': { font: 'fr8bot-icons', char: '\uf181' },
  'log-out-16': { font: 'fr8bot-icons', char: '\uf180' },
  'mail-16': { font: 'fr8bot-icons', char: '\uf17f' },
  'mail-20': { font: 'fr8bot-icons', char: '\uf17e' },
  'mail-32': { font: 'fr8bot-icons', char: '\uf17d' },
  'mail-50': { font: 'fr8bot-icons', char: '\uf17c' },
  'mainpage-contact-mail': { font: 'fr8bot-icons', char: '\uf10d', aspect: 1.3043 },
  'mainpage-contact-phone': { font: 'fr8bot-icons', char: '\uf17b' },
  'manager-20': { font: 'fr8bot-icons', char: '\uf17a' },
  'manager-50': { font: 'fr8bot-icons', char: '\uf179' },
  'map pointer 2': { font: 'fr8bot-icons', char: '\uf178' },
  'map-16': { font: 'fr8bot-icons', char: '\uf177' },
  'map-20': { font: 'fr8bot-icons', char: '\uf176' },
  'map-point-16': { font: 'fr8bot-icons', char: '\uf175' },
  'map-point-32': { font: 'fr8bot-icons', char: '\uf174' },
  'map-point-solid-12': { font: 'fr8bot-icons', char: '\uf173' },
  'map-point-solid-16': { font: 'fr8bot-icons', char: '\uf172' },
  'map-point-solid-32': { font: 'fr8bot-icons', char: '\uf171' },
  'map-pointer-2-16': { font: 'fr8bot-icons', char: '\uf170' },
  'map-pointer-2-20': { font: 'fr8bot-icons', char: '\uf16f' },
  'menu-x': { font: 'fr8bot-icons', char: '\uf16e' },
  'message-16': { font: 'fr8bot-icons', char: '\uf16d' },
  'metric-16': { font: 'fr8bot-icons', char: '\uf1fe' },
  'minus-16': { font: 'fr8bot-icons', char: '\uf16c' },
  'more-16': { font: 'fr8bot-icons', char: '\uf16b' },
  'move-12': { font: 'fr8bot-icons', char: '\uf16a' },
  'neutrally-32': { font: 'fr8bot-icons', char: '\uf169' },
  'notes-16': { font: 'fr8bot-icons', char: '\uf168' },
  'notes-20': { font: 'fr8bot-icons', char: '\uf167' },
  'notification-20': { font: 'fr8bot-icons', char: '\uf166' },
  'on-the-way': { font: 'fr8bot-icons', char: '\uf216', aspect: 8.3333 },
  'passport-32': { font: 'fr8bot-icons', char: '\uf165' },
  'passport-50': { font: 'fr8bot-icons', char: '\uf164' },
  'password-16': { font: 'fr8bot-icons', char: '\uf163' },
  'password-50': { font: 'fr8bot-icons', char: '\uf162' },
  'path-16': { font: 'fr8bot-icons', char: '\uf161' },
  'path-20': { font: 'fr8bot-icons', char: '\uf160' },
  'path-50': { font: 'fr8bot-icons', char: '\uf15f' },
  'percent-16': { font: 'fr8bot-icons', char: '\uf21d' },
  'phone-16': { font: 'fr8bot-icons', char: '\uf15e' },
  'phone-32': { font: 'fr8bot-icons', char: '\uf15d' },
  'phone-50': { font: 'fr8bot-icons', char: '\uf15c' },
  'photo-camera-16': { font: 'fr8bot-icons', char: '\uf15b' },
  'photo-camera-20': { font: 'fr8bot-icons', char: '\uf15a' },
  'photo-camera-32': { font: 'fr8bot-icons', char: '\uf159' },
  'photo-camera-50': { font: 'fr8bot-icons', char: '\uf158' },
  'photo-camera-no-16': { font: 'fr8bot-icons', char: '\uf157' },
  'plane-solid-12': { font: 'fr8bot-icons', char: '\uf156' },
  'plane-solid-16': { font: 'fr8bot-icons', char: '\uf155' },
  'plane-solid-32': { font: 'fr8bot-icons', char: '\uf154' },
  'plus-16': { font: 'fr8bot-icons', char: '\uf153' },
  'plus-32': { font: 'fr8bot-icons', char: '\uf152' },
  'pointer-50': { font: 'fr8bot-icons', char: '\uf151' },
  'profile-16': { font: 'fr8bot-icons', char: '\uf150' },
  'profile-2-16': { font: 'fr8bot-icons', char: '\uf14f' },
  'profile-20': { font: 'fr8bot-icons', char: '\uf14e' },
  'profile-32': { font: 'fr8bot-icons', char: '\uf14d' },
  'profile-50': { font: 'fr8bot-icons', char: '\uf14c' },
  'profile-card-16': { font: 'fr8bot-icons', char: '\uf14b' },
  'profile-card-20': { font: 'fr8bot-icons', char: '\uf14a' },
  'profile-new-16': { font: 'fr8bot-icons', char: '\uf149' },
  'profile-with-something-16': { font: 'fr8bot-icons', char: '\uf148' },
  'question-16': { font: 'fr8bot-icons', char: '\uf147' },
  'question-50': { font: 'fr8bot-icons', char: '\uf146' },
  reload: { font: 'fr8bot-icons', char: '\uf143' },
  'reload-12': { font: 'fr8bot-icons', char: '\uf145' },
  'reload-16': { font: 'fr8bot-icons', char: '\uf144' },
  'replace-16': { font: 'fr8bot-icons', char: '\uf142' },
  'reply-16': { font: 'fr8bot-icons', char: '\uf1fa', aspect: 1.0625 },
  'req-ac': { font: 'fr8bot-icons', char: '\uf215', aspect: 2 },
  'req-air-ride': { font: 'fr8bot-icons', char: '\uf214', aspect: 2 },
  'req-dock-high': { font: 'fr8bot-icons', char: '\uf213', aspect: 2 },
  'req-hazmat': { font: 'fr8bot-icons', char: '\uf212', aspect: 2 },
  'req-heater': { font: 'fr8bot-icons', char: '\uf211', aspect: 2 },
  'req-lift-fate-with-line': { font: 'fr8bot-icons', char: '\uf210', aspect: 7.8333 },
  'req-lift-gate': { font: 'fr8bot-icons', char: '\uf20f', aspect: 2 },
  'req-pallet-jack': { font: 'fr8bot-icons', char: '\uf20e', aspect: 2 },
  'req-size': { font: 'fr8bot-icons', char: '\uf20d', aspect: 2 },
  'req-speed': { font: 'fr8bot-icons', char: '\uf20b', aspect: 2 },
  'req-speed-with-line': { font: 'fr8bot-icons', char: '\uf20c', aspect: 7.8333 },
  'revenue-16': { font: 'fr8bot-icons', char: '\uf141' },
  'revenue-20': { font: 'fr8bot-icons', char: '\uf140' },
  'revenue-32': { font: 'fr8bot-icons', char: '\uf13f' },
  'revenue-50': { font: 'fr8bot-icons', char: '\uf13e' },
  'revenue-with-line': { font: 'fr8bot-icons', char: '\uf20a', colour: '#7D7D7D', aspect: 8 },
  'review-16': { font: 'fr8bot-icons', char: '\uf13d' },
  'rotate-l-16': { font: 'fr8bot-icons', char: '\uf13c' },
  'rotate-left-16': { font: 'fr8bot-icons', char: '\uf13b' },
  'rotate-phone': { font: 'fr8bot-icons', char: '\uf139' },
  'rotate-phone-2': { font: 'fr8bot-icons', char: '\uf13a' },
  'rotate-r-16': { font: 'fr8bot-icons', char: '\uf138' },
  'rotate-right-16': { font: 'fr8bot-icons', char: '\uf137' },
  'routing-number-16': { font: 'fr8bot-icons', char: '\uf136' },
  'search-16': { font: 'fr8bot-icons', char: '\uf135' },
  'search-50': { font: 'fr8bot-icons', char: '\uf134' },
  'ship-16': { font: 'fr8bot-icons', char: '\uf133' },
  'ship-solid-12': { font: 'fr8bot-icons', char: '\uf132' },
  'ship-solid-32': { font: 'fr8bot-icons', char: '\uf131' },
  'shipper-16': { font: 'fr8bot-icons', char: '\uf130' },
  'shipper-20': { font: 'fr8bot-icons', char: '\uf12f' },
  'shipper-50': { font: 'fr8bot-icons', char: '\uf1f9', aspect: 0.9804 },
  'star-16': { font: 'fr8bot-icons', char: '\uf12e' },
  'start-border': { font: 'fr8bot-icons', char: '\uf10c' },
  'start-fill': { font: 'fr8bot-icons', char: '\uf12d' },
  'steering-wheel-16': { font: 'fr8bot-icons', char: '\uf12c' },
  'step-cards-20': { font: 'fr8bot-icons', char: '\uf12b' },
  'structure-16': { font: 'fr8bot-icons', char: '\uf12a' },
  'support-16': { font: 'fr8bot-icons', char: '\uf129' },
  'support-20': { font: 'fr8bot-icons', char: '\uf128' },
  'support-32': { font: 'fr8bot-icons', char: '\uf127' },
  'support-50': { font: 'fr8bot-icons', char: '\uf126' },
  'suspended-16': { font: 'fr8bot-icons', char: '\uf125' },
  'suspended-50': { font: 'fr8bot-icons', char: '\uf124' },
  'tag-50': { font: 'fr8bot-icons', char: '\uf123' },
  'template-12': { font: 'fr8bot-icons', char: '\uf122' },
  'template-16': { font: 'fr8bot-icons', char: '\uf200' },
  'trash-16': { font: 'fr8bot-icons', char: '\uf121' },
  'twic-50': { font: 'fr8bot-icons', char: '\uf120' },
  'twic-back-180x250': { font: 'fr8bot-icons', char: '\uf21c', aspect: 0.72 },
  'twic-front-180x250': { font: 'fr8bot-icons', char: '\uf21b', aspect: 0.72 },
  'unassign-16': { font: 'fr8bot-icons', char: '\uf11f' },
  'unread-16': { font: 'fr8bot-icons', char: '\uf11e' },
  'up-down-50': { font: 'fr8bot-icons', char: '\uf11d' },
  'upload-16': { font: 'fr8bot-icons', char: '\uf11c' },
  'van-16': { font: 'fr8bot-icons', char: '\uf11b' },
  'van-20': { font: 'fr8bot-icons', char: '\uf11a' },
  'van-24': { font: 'fr8bot-icons', char: '\uf1f7', aspect: 1.5 },
  'van-32': { font: 'fr8bot-icons', char: '\uf119' },
  'van-50': { font: 'fr8bot-icons', char: '\uf118' },
  'van-back-180x250': { font: 'fr8bot-icons', char: '\uf209', aspect: 0.72 },
  'van-cargo-space-180x250': { font: 'fr8bot-icons', char: '\uf208', aspect: 0.72 },
  'van-front-180x250': { font: 'fr8bot-icons', char: '\uf207', aspect: 0.72 },
  'van-left-side-180x250': { font: 'fr8bot-icons', char: '\uf206', aspect: 0.72 },
  'van-new-20': { font: 'fr8bot-icons', char: '\uf117' },
  'van-new-50': { font: 'fr8bot-icons', char: '\uf116' },
  'van-plate-16': { font: 'fr8bot-icons', char: '\uf115' },
  'van-plate-20': { font: 'fr8bot-icons', char: '\uf114' },
  'van-right-side-180x250': { font: 'fr8bot-icons', char: '\uf205', aspect: 0.72 },
  'visible-no-16': { font: 'fr8bot-icons', char: '\uf113' },
  'visible-yes-16': { font: 'fr8bot-icons', char: '\uf112' },
  'warning-16': { font: 'fr8bot-icons', char: '\uf111' },
  'warning-20': { font: 'fr8bot-icons', char: '\uf110' },
  'web-aero-docs': { font: 'fr8bot-landing-icons', char: '\uf117', colour: '#C1D91C' },
  'web-agro': { font: 'fr8bot-landing-icons', char: '\uf116', colour: '#C1D91C' },
  'web-business': { font: 'fr8bot-landing-icons', char: '\uf115', colour: '#C1D91C' },
  'web-car': { font: 'fr8bot-landing-icons', char: '\uf114', colour: '#C1D91C' },
  'web-checkmark-approved': { font: 'fr8bot-landing-icons', char: '\uf113', colour: '#C1D91C' },
  'web-choose': { font: 'fr8bot-landing-icons', char: '\uf112', colour: '#C1D91C' },
  'web-facebook': { font: 'fr8bot-landing-icons', char: '\uf111' },
  'web-instagram': { font: 'fr8bot-landing-icons', char: '\uf110' },
  'web-linkedin': { font: 'fr8bot-landing-icons', char: '\uf10f' },
  'web-manufactory': { font: 'fr8bot-landing-icons', char: '\uf10e', colour: '#C1D91C' },
  'web-map': { font: 'fr8bot-landing-icons', char: '\uf10d', colour: '#C1D91C' },
  'web-page': { font: 'fr8bot-landing-icons', char: '\uf10c', colour: '#C1D91C' },
  'web-path': { font: 'fr8bot-landing-icons', char: '\uf10b', colour: '#C1D91C' },
  'web-pharma': { font: 'fr8bot-landing-icons', char: '\uf10a', colour: '#C1D91C' },
  'web-plane': { font: 'fr8bot-landing-icons', char: '\uf109', colour: '#C1D91C' },
  'web-plug': { font: 'fr8bot-landing-icons', char: '\uf108', colour: '#C1D91C' },
  'web-polygon': { font: 'fr8bot-landing-icons', char: '\uf11a', colour: '#C1D91C', aspect: 1.2 },
  'web-progress-01': {
    font: 'fr8bot-landing-icons',
    char: '\uf11e',
    colour: '#C1D91C80',
    aspect: 1.2936,
  },
  'web-progress-02': {
    font: 'fr8bot-landing-icons',
    char: '\uf11d',
    colour: '#C1D91C80',
    aspect: 1.6055,
  },
  'web-progress-03': {
    font: 'fr8bot-landing-icons',
    char: '\uf11c',
    colour: '#C1D91C80',
    aspect: 1.6239,
  },
  'web-progress-checkmark': { font: 'fr8bot-landing-icons', char: '\uf11b', colour: '#25BB73' },
  'web-progress-empty': { font: 'fr8bot-landing-icons', char: '\uf119', colour: '#323232' },
  'web-progress-van': { font: 'fr8bot-landing-icons', char: '\uf118', colour: '#C1D91C' },
  'web-revenue': { font: 'fr8bot-landing-icons', char: '\uf107', colour: '#C1D91C' },
  'web-shield': { font: 'fr8bot-landing-icons', char: '\uf106', colour: '#C1D91C' },
  'web-stage': { font: 'fr8bot-landing-icons', char: '\uf105', colour: '#C1D91C' },
  'web-support': { font: 'fr8bot-landing-icons', char: '\uf104', colour: '#C1D91C' },
  'web-tracking': { font: 'fr8bot-landing-icons', char: '\uf103', colour: '#C1D91C' },
  'web-wirehouse': { font: 'fr8bot-landing-icons', char: '\uf102', colour: '#C1D91C' },
  'web-youtube': { font: 'fr8bot-landing-icons', char: '\uf101' },
  'weight-32': { font: 'fr8bot-icons', char: '\uf10b' },
  'withdraw-50': { font: 'fr8bot-icons', char: '\uf10a' },
  'work-card-32': { font: 'fr8bot-icons', char: '\uf109' },
  'work-card-50': { font: 'fr8bot-icons', char: '\uf108' },
  x: { font: 'fr8bot-icons', char: '\uf101' },
  'x-1-12': { font: 'fr8bot-icons', char: '\uf107' },
  'x-1-16': { font: 'fr8bot-icons', char: '\uf106' },
  'x-2-16': { font: 'fr8bot-icons', char: '\uf105' },
  'x-2-20': { font: 'fr8bot-icons', char: '\uf104' },
  'x-2-32': { font: 'fr8bot-icons', char: '\uf103' },
  'x-2-50': { font: 'fr8bot-icons', char: '\uf102' },
};
